import NetsuiteData from '../types/NetsuiteData'

export const state: NetsuiteData = {
  customer: null,
  orders: null,
  currentOrder: null,
  tracking: null,
  loading: false,
  submitting: false,
  error: null
}
